import ScrollTrigger from 'gsap/ScrollTrigger';
import { ParticleWaveBackground } from '../lib/ParticleWaveBackground';

export function initAllSubscribeBlocks() {
  const blocks = document.querySelectorAll('.js-subscribe-block');
  blocks.forEach((block) => initSubscribeBlock(block));
}

export function initSubscribeBlock(parent) {
  if (!parent) return;

  const bg = parent.querySelector('.subscribe-block__bg');
  if (bg) {
    const animation = new ParticleWaveBackground(
      bg,
      {
        autoStart: false,
        planeWidth: 13.699,
        planeHeight: 5.282,
        widthSegments: 120,
        heightSegments: 70,
        particleSize: 0.035,
        waveHeight: 0.5,
        noiseScale: 2,
        animationSpeed: 6000,
        gradient: [
          { color: '#ffffffff', stop: 0 },
          { color: '#ffffffbb', stop: 100 },
        ],
        rotation: {
          x: -0.797964534011807,
          y: 0.282743338823081,
          z: -0.100530964914873,
        },
        cameraPosition: [-4.26, -0.58, 5],
        cameraRotation: { x: 0, y: 0, z: 0 },
      },
      parent,
    );
    ScrollTrigger.create({
      trigger: parent,
      start: 'top bottom',
      end: 'bottom top',
      onEnter: () => animation.startAnimation(),
      onLeave: () => animation.stopAnimation(),
      onEnterBack: () => animation.startAnimation(),
      onLeaveBack: () => animation.stopAnimation(),
    });
  }
}
